import React, { useEffect, useMemo, useState } from 'react';
import api from '../../../api';
import DashboardLayout from '../../../Components/Dashboard/DashboardLayout';
import './AdminSuite.css';

const CompanyPage = () => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const load = async () => {
      const res = await api.get('/admin/users');
      setUsers(res.data?.data || []);
    };

    load();
  }, []);

  const companyUsers = useMemo(
    () => users.filter(u => u.accountType === 'company' || u.role === 'company'),
    [users]
  );

  return (
    <DashboardLayout>
      <div className="container py-4 admin-suite">
        <div className="admin-suite-header">
          <div>
            <h3 className="admin-suite-title">Company Page</h3>
            <p className="admin-suite-subtitle">Modern company workspace and team account overview.</p>
          </div>
          <span className="badge bg-light text-dark">Accounts: {companyUsers.length}</span>
        </div>

        <div className="admin-modern-panel">
          <h5 className="mb-2">Company Accounts</h5>
          {!companyUsers.length ? (
            <p className="text-muted mb-0">No users with company role found yet.</p>
          ) : (
            <div className="admin-company-list">
              {companyUsers.map(user => (
                <div key={user.id} className="admin-company-item">
                  <strong>{user.fullName || user.name || 'Unnamed User'}</strong>
                  <span className="text-muted">{user.email}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default CompanyPage;
